module.exports = __webpack_public_path__ + "img/ChrisEmmet.61cfee45.jpg";